import React, { Fragment } from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPlus, faEdit, faTimes } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import { invalidNumber } from "../helpers/index";
import SelectInput from "./SelectInput";
import { compose, setDisplayName } from "recompose";
import NextForm from "../containers/NextForm";
import CheckboxInput from "./CheckboxInput";

const propTypes = {
  submittingItem: PropTypes.bool.isRequired,
  failSubmitItem: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  clearItem: PropTypes.func.isRequired,
  initialValues: PropTypes.object
};

const serviceTypes = [
  {
    label: "For Hours",
    value: "for_hours"
  },
  {
    label: "Flat Fee",
    value: "flat_fee"
  }
];

const ItemForm = compose(
  setDisplayName("ItemForm"),
  NextForm
)(
  ({
    onSubmit,
    initialValues,
    submittingItem,
    failSubmitItem,
    currentItem,
    clearItem,
    inputs,
    focusNextField,
    children
  }) => {
    return (
      <div>
        <Formik
          enableReinitialize
          onSubmit={onSubmit}
          validate={validate}
          initialValues={initialValues}
          render={({ submitForm, values }) => {
            return (
              <Form>
                <div className="row">
                  {values.type_service === "for_hours" && (
                    <Fragment>
                      <div className="col-md-2 col-sm-12 pr-md-1">
                    <Field
                      name="type_service"
                      component={SelectInput}
                      source={serviceTypes}
                    />
                  </div>
                      <div className="col-md-2 col-sm-12 px-md-1">
                        <Field
                          innerRef={input => (inputs.labor_time = input)}
                          onKeyPress={focusNextField("part_price")}
                          name="labor_time"
                          component={TextInput}
                          placeholder="Labor Hours"
                        />
                      </div>
                      <div className="col-md-3 col-sm-12 px-md-1">
                        <Field
                          innerRef={input => (inputs.part_price = input)}
                          onKeyPress={focusNextField("reason")}
                          name="part_price"
                          component={TextInput}
                          placeholder="Part Price"
                        />
                      </div>
                    </Fragment>
                  )}
                  {values.type_service === "flat_fee" && (
                    <Fragment>
                    <div className="col-md-2 col-sm-12 pr-md-1">
                    <Field
                      name="type_service"
                      component={SelectInput}
                      source={serviceTypes}
                    /></div>
                    <div className="col-md-3 col-sm-12 pr-md-1">
                      <Field
                        innerRef={input => (inputs.flat_fee = input)}
                        onKeyPress={focusNextField("reason")}
                        name="flat_fee"
                        component={TextInput}
                        placeholder="Price"
                      />
                    </div>
                    </Fragment>
                  )}
                  <div className="col-md-3 col-sm-12 pl-md-1">
                    <Field
                      innerRef={input => (inputs.reason = input)}
                      onKeyPress={ev => {
                        if (ev.key === "Enter") {
                          inputs.reason.blur();
                          submitForm();
                        }
                      }}
                      name="reason"
                      component={TextInput}
                      type="textarea"
                      placeholder="Description"
                    />
                  </div>
                  <div className="col-md-2">
                    <Field
                        name='taxable'
                        number='taxable'
                        label='Taxable'
                        component={CheckboxInput}
                      />
                  </div>
                  
                </div>
                <div className="row">
                  <div className="col-md-auto col-sm-12 pr-md-1 mb-3">
                    <Button
                      fill
                      block
                      type="button"
                      onClick={submitForm}
                      disabled={submittingItem}
                      color="info"
                    >
                      {`${currentItem ? "Update" : "Add"} Service `}
                      <FontAwesomeIcon icon={currentItem ? faEdit : faPlus} />
                    </Button>
                  </div>
                  {currentItem && (
                    <div className="col-md-auto col-sm-12 pr-md-1 mb-3">
                      <Button
                        block
                        color="info"
                        type="button"
                        onClick={clearItem}
                      >
                        Clear <FontAwesomeIcon icon={faTimes} />
                      </Button>
                    </div>
                  )}
                  {children && children({ inputs })}
                </div>
                {failSubmitItem && (
                  <div className="row">
                    <div className="col">
                      <Alert color="danger">{failSubmitItem}</Alert>
                    </div>
                  </div>
                )}
              </Form>
            );
          }}
        />
      </div>
    );
  }
);

ItemForm.propTypes = propTypes;

const validate = values => {
  let errors = {};
  if (!values.reason) {
    errors.reason = "Required";
  }
  if (!values.type_service) {
    errors.type_service = "Required";
  } else if (values.type_service === "for_hours") {
    if (invalidNumber(values.labor_time)) {
      errors.labor_time = "Number Required";
    }
    if (invalidNumber(values.part_price)) {
      errors.part_price = "Number Required";
    }
  } else {
    if (invalidNumber(values.flat_fee)) {
      errors.flat_fee = "Number Required";
    }
  }
  return errors;
};

export default ItemForm;
